import React, { HTMLAttributes, forwardRef } from "react";
import classNames from "classnames";

interface LongShortLabelProps extends HTMLAttributes<HTMLDivElement> {
   long: string;
   short: string;
}
const LongShortLabel = forwardRef<HTMLDivElement, LongShortLabelProps>(({ long, short, className, ...rest }, ref) =>
   <div className={classNames("lsl-wrapper", className)} ref={ref} {...rest}>
      <div className="lsl-short">{short}</div>
      <div className="lsl-long">{long}</div>
   </div>);

export default LongShortLabel;